var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"text-r-black-50 uppercase font-bold transition-all duration-100 flex flex-row space-x-2 hover:text-r-gray items-center text-sm md:text-base",on:{"click":function($event){return _vm.$emit('clicked')}}},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }